<template>
	<div class="workBench">
		<div class="approvalCenter">
			<div class="title">
				审批中心
			</div>
			<div class="boxWrap">
				<div
					class="singleBox point"
					@click="jumpUrl('pendingApproval')"
				>
					<div class="boxTile">
						待审批
					</div>
					<div class="boxCenter">
						{{ numData.underApply }}
					</div>
				</div>
				<div class="singleBox">
					<div class="boxTile">
						今日已处理
					</div>
					<div class="boxCenter">
						{{ numData.processed }}
					</div>
				</div>
				<div class="singleBox">
					<div class="boxTile">
						环比
					</div>
					<div class="boxCenter">
						{{ numData.processedRelativeRatio }}
					</div>
				</div>
				<div
					class="singleBox point"
					@click="jumpUrl('approvalHistory')"
				>
					<div class="boxTile">
						审批历史
					</div>
					<div class="boxCenter">
						{{ numData.auditHistory }}
					</div>
				</div>
				<div
					class="singleBox point"
					@click="jumpUrl('rejectedApproval')"
				>
					<div class="boxTile">
						已驳回
					</div>
					<div class="boxCenter">
						{{ numData.rejected }}
					</div>
				</div>
			</div>
		</div>
		<div class="approvalCenter">
			<div class="title">
				任务中心
			</div>
			<div class="boxWrap">
				<div class="singleBox">
					<div class="boxTile">
						今日已提交
					</div>
					<div class="boxCenter">
						{{ numData.submitted }}
					</div>
				</div>
				<div class="singleBox">
					<div class="boxTile">
						审批完成
					</div>
					<div class="boxCenter">
						{{ numData.auditFinish }}
					</div>
				</div>
				<div class="singleBox">
					<div class="boxTile">
						环比
					</div>
					<div class="boxCenter">
						{{ numData.auditFinishRelativeRatio }}
					</div>
				</div>
				<div class="singleBox  point" @click="jumpUrl('latestDocumentNews')">
					<div class="boxTile">
						公文消息
					</div>
					<div class="boxCenter">
						{{ documentMsg }}
					</div>
				</div>
				<div class="singleBox  point" @click="jumpUrl('submitUnapproval')">
					<div class="boxTile">
						已提交未审批
					</div>
					<div class="boxCenter">
						{{ numData.processingAll }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getWorkBenchBasicDataApi } from "../../../services/workbenchServices";
import { getUnreadLatestFileCount } from "../../../services/sysSettingService";

export default {
	name: "workbench",
	data() {
		return {
			documentMsg:0,  //公文消息
			numData: {
				underApply: 0, //待审批
				processed: 0, //今日已处理
				processedRelativeRatio: "0%", //今日已处理环比
				auditHistory: 0, //审批历史
				submitted: 0, //今日已提交
				auditFinish: 0, //审批完成
				auditFinishRelativeRatio: "0%", //审批完成环比
			},
		};
	},

	methods: {
		getInitData() {
			getWorkBenchBasicDataApi()
				.then((res) => {
					if (res.code == 10000000) {
						this.numData = res.data || {
							underApply: 0, //待审批
							processed: 0, //今日已处理
							processedRelativeRatio: "0%", //今日已处理环比
							auditHistory: 0, //审批历史
							submitted: 0, //今日已提交
							auditFinish: 0, //审批完成
							auditFinishRelativeRatio: "0%", //审批完成环比
						};
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch(() => {
					this.$message.error("网络请求失败");
				});
			this.getDocumentData();
		},
		//获取公文消息条数
		getDocumentData(){
			getUnreadLatestFileCount()
				.then((res) => {
					if (res.code == 10000000) {
						this.documentMsg = res.data || 0;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch(() => {
					this.$message.error("网络请求失败");
				});

		},
		//跳转页面
		jumpUrl(url) {
			this.bus.$emit("navMenuChange", {
				routeId: url,
			});
		},
	},
	created() {
		this.getInitData();
		
	},
	mounted(){
		this.bus.$on("headerActiveTabName", (item) => {
			if (item === "工作台") {
				this.getInitData();
			}
		});

	},
	 beforeDestroy(){        //收尾操作，销毁
            this.bus.$off('headerActiveTabName')  //$off解绑当前组件所用到的事件
        }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";

.workBench {
	height: 100%;
	background-color: white;
	display: flex;
	flex-direction: column;

	.approvalCenter {
		border-radius: 4px;
		margin: 60px auto 0;
		width: 80%;

		.title {
			font-size: 20px;
			margin-bottom: 10px;
		}

		.boxWrap {
			display: flex;
			margin-bottom: 40px;

			.point {
				cursor: pointer;
			}

			.singleBox {
				border-radius: 4px;
				text-align: center;
				width: 160px;
				box-sizing: border-box;
				background: rgb(233, 244, 250);
				margin-right: 20px;

				.boxTile {
					margin: 20px 20px 0 20px;
					font-size: 18px;
				}

				.boxCenter {
					font-size: 30px;
					font-weight: bold;
					margin: 20px;
				}
			}
		}
	}
}
</style>
